import { IDishesContext, IFilterValues } from './dishesContext';

export enum DishesActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_DISHES_BY_CUSTOMER = 'SET_DISHES_BY_CUSTOMER',
	SET_DISHES_BY_RESTAURANT = 'SET_DISHES_BY_RESTAURANT',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	TOGGLE_REMEMBER_MY_CHOICE = 'TOGGLE_REMEMBER_MY_CHOICE',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	SET_ID_SUBCATEGORY = 'SET_ID_SUBCATEGORY',
	TOGGLE_IS_DISABLED = 'TOGGLE_IS_DISABLED',
	TOGGLE_ASSIGNED = 'TOGGLE_ASSIGNED',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_ASSIGN_RESTAURANTS = 'SET_ID_FOR_ASSIGN_RESTAURANTS',
	SET_ID_FOR_EDIT_MOD_GROUP_TEMPLATE = 'SET_ID_FOR_EDIT_MOD_GROUP_TEMPLATE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface IRefetchData {
	type: DishesActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IDishesContext['needRefetchData'];
	};
}

interface ISetDishesByCustomer {
	type: DishesActionTypes.SET_DISHES_BY_CUSTOMER;
	payload: {
		dishesByCustomer: IDishesContext['dishesByCustomer'];
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface ISetDishesByRestaurant {
	type: DishesActionTypes.SET_DISHES_BY_RESTAURANT;
	payload: {
		dishesByRestaurant: IDishesContext['dishesByRestaurant'];
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: DishesActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IDishesContext['searchString'];
	};
}

interface IToggleRememberMyChoice {
	type: DishesActionTypes.TOGGLE_REMEMBER_MY_CHOICE;
	payload: {
		rememberMyChoice: IDishesContext['rememberMyChoice'];
	};
}

interface ISetFetchedCustomers {
	type: DishesActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IDishesContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: DishesActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IDishesContext['IDSelectedCustomer'];
		dishesByCustomer: IDishesContext['dishesByCustomer'];
		dishesByRestaurant: IDishesContext['dishesByRestaurant'];
	};
}

interface ISetIDRestaurant {
	type: DishesActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IDishesContext['IDSelectedRestaurant'];
		isDisabled: IDishesContext['isDisabled'];
		assigned: IDishesContext['assigned'];
	};
}

interface ISetIDCategory {
	type: DishesActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: IDishesContext['IDSelectedCategory'];
	};
}

interface ISetIDSubcategory {
	type: DishesActionTypes.SET_ID_SUBCATEGORY;
	payload: {
		IDSelectedSubcategory: IDishesContext['IDSelectedSubcategory'];
	};
}

interface IToggleIsDisabled {
	type: DishesActionTypes.TOGGLE_IS_DISABLED;
	payload: {
		isDisabled: IDishesContext['isDisabled'];
	};
}

interface IToggleAssigned {
	type: DishesActionTypes.TOGGLE_ASSIGNED;
}

interface IResetSelectedControls {
	type: DishesActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: DishesActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IDishesContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: DishesActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IDishesContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: DishesActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IDishesContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: DishesActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IDishesContext['IDForDeletion'];
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface ISetIDForAssignRestaurant {
	type: DishesActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS;
	payload: {
		IDForAssignRestaurants: IDishesContext['IDForDeletion'];
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface ISetIDForEditModGroupTemplate {
	type: DishesActionTypes.SET_ID_FOR_EDIT_MOD_GROUP_TEMPLATE;
	payload: {
		IDForEditModGroupTemplate: IDishesContext['IDForEditModGroupTemplate'];
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: DishesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: DishesActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TDishesAction =
	| IRefetchData
	| ISetDishesByCustomer
	| ISetDishesByRestaurant
	| IChangeSearchString
	| IToggleRememberMyChoice
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDCategory
	| ISetIDSubcategory
	| IToggleIsDisabled
	| IToggleAssigned
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForAssignRestaurant
	| ISetIDForEditModGroupTemplate
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
